import { PagerItem, PagerLink } from 'design-react-kit/dist/design-react-kit';

import { Component } from 'react';
import { Icon } from '@arpav/components/ArpavTheme';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import keyboardKey from 'keyboard-key';

/**
 * An item of a pagination.
 */
class PaginationItem extends Component {
  static propTypes = {
    /** A pagination item can be active. */
    active: PropTypes.bool,

    /** A pagination item can be disabled. */
    disabled: PropTypes.bool,

    /**
     * Called on click.
     *
     * @param {SyntheticEvent} event - React's original SyntheticEvent.
     * @param {object} data - All props.
     */
    onClick: PropTypes.func,

    /** A pagination should have a type. */
    type: PropTypes.oneOf([
      'ellipsisItem',
      'firstItem',
      'prevItem',
      'pageItem',
      'nextItem',
      'lastItem',
    ]),
  };

  handleClick = e => {
    _.invoke(this.props, 'onClick', e, this.props);
  };

  handleKeyDown = e => {
    _.invoke(this.props, 'onKeyDown', e, this.props);
    if (keyboardKey.getCode(e) === keyboardKey.Enter)
      _.invoke(this.props, 'onClick', e, this.props);
  };

  render() {
    const { active, type, children, intl, ellipsisItem } = this.props;
    const disabled = this.props.disabled || type === 'ellipsisItem';
    return (
      <PagerItem disabled={disabled}>
        <PagerLink
          href=""
          onClick={this.handleClick}
          onKeyDown={this.handleKeyDown}
          aria-current={active ? 'page' : null}
        >
          {type === 'prevItem' && (
            <>
              <Icon icon="it-chevron-left" style={{ ariaHidden: true }} color="primary" />

              <span className="sr-only">
                {intl.formatMessage({
                  id: 'Previous page',
                })}
              </span>
            </>
          )}
          {type === 'nextItem' && (
            <>
              <Icon icon="it-chevron-right" style={{ ariaHidden: true }} color="primary" />
              <span className="sr-only">
                {intl.formatMessage({
                  id: 'Next page',
                })}
              </span>
            </>
          )}
          {type === 'ellipsisItem' && (
            <>
              {ellipsisItem}
              <span className="sr-only">
                {intl.formatMessage({
                  id: 'Next page',
                })}
              </span>
            </>
          )}
          {['prevItem', 'nextItem', 'ellipsisItem'].indexOf(type) < 0 && children}
        </PagerLink>
      </PagerItem>
    );
  }
}

export default injectIntl(PaginationItem);
